"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MIN_WS_TIMEOUT: function() {
        return MIN_WS_TIMEOUT;
    },
    WS_TIMEOUT: function() {
        return WS_TIMEOUT;
    }
});
var MIN_WS_TIMEOUT = 1000;
var WS_TIMEOUT = 30000;

//# sourceMappingURL=defaults.js.map